interface Props {
  size?: number;
  color?: string;
}

const CircularCheckIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 26 26"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M25.5 13c0 6.904-5.596 12.5-12.5 12.5S.5 19.904.5 13 6.096.5 13 .5 25.5 6.096 25.5 13m-7.462-3.788a.94.94 0 0 1 0 1.326l-6.25 6.25a.937.937 0 0 1-1.326 0l-2.5-2.5a.937.937 0 1 1 1.326-1.326l1.837 1.837 2.794-2.793 2.793-2.794a.937.937 0 0 1 1.326 0"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default CircularCheckIcon;
